import { MenuItem } from '@mui/material';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const CapitalizedMenuItem = styled(MenuItem)`
  text-transform: capitalize;
`;
